import type { FeatureAccessOptions } from '@blueshift-ui/auth/dist/types';

import useAuthenticatedUser from '@blueshift-ui/auth/dist/hooks/use-authenticated-user';
import useFeatureAccess from '@blueshift-ui/auth/dist/hooks/use-feature-access';

const DEFAULT_NAV_SLUG = 'vt_freemium_navbar';

const USER_NAV_SLUG_MAP: ReadonlyMap<string, string> = new Map([
  ['one_on_one_membership', 'vt_membership_navbar_standard_subjects'],
  ['vt4s_client', 'vt4s_parent_assigned_navbar'],
  ['vt4s_student', 'vt4s_student_navbar'],
]);

const VT4S_USER_CRITERIA: FeatureAccessOptions = {
  productState: (userProductState) => userProductState === 'vt4s',
};

function useNavSlug() {
  const { isLoading: isLoadingUser, data: user } = useAuthenticatedUser();

  const { isLoading: isLoadingAccess, hasAccess: isVt4sClient } = useFeatureAccess({
    criteria: VT4S_USER_CRITERIA,
  });

  if (isLoadingUser || isLoadingAccess) {
    return;
  }

  const navSlugKey = isVt4sClient ? `vt4s_${user?.role}` : user?.product_state ?? '';
  return USER_NAV_SLUG_MAP.get(navSlugKey) ?? DEFAULT_NAV_SLUG;
}

export default useNavSlug;
